import { useQuery } from '@apollo/react-hooks';

export default function useShop(user, query, variables = {}, fetchPolicy = 'no-cache') {
	let userId =
		typeof user === 'string' && user.match(/[a-z0-9][a-z0-9\-]*\.myshopify\.com/i) ? user : user.attributes.website;
	let { data, loading, error } = useQuery(query, {
		variables: { userId, ...variables },
		fetchPolicy,
	});
	return { data, loading, error };
}
